<template>
    <v-card class="rounded-lg">
      <v-toolbar
          class="removeBtnPaddingRight pl-2"
          color="#DADADA"
          dense
          flat
      >
        <slot name="btn"></slot>
      </v-toolbar>
      <v-card-title>
        <v-row no-gutters class="text-left">
          <v-col cols="12" md="1" class="font-weight-bold">ФИО:</v-col>
          <v-col cols="12" md="11" class="text-break">{{ item.last_name }} {{ item.first_name }} {{ item.middle_name }}</v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row no-gutters class="text-left subtitle-1 py-1">
          <v-col cols="12" md="2" class="font-weight-bold">Организация:</v-col>
          <v-col cols="12" md="10" class="text-break">{{ item.organization.full_name }}</v-col>
        </v-row>
        <v-row no-gutters class="text-left subtitle-1 py-1">
          <v-col cols="11" md="4" class="font-weight-bold">Является иностранным гражданином:</v-col>
          <v-col cols="1">
            <v-icon
                :color="checkFlag(item.is_foreigner).color"
            >
              {{checkFlag(item.is_foreigner).icon}}
            </v-icon>
          </v-col>
          <v-col cols="11" md="3" class="font-weight-bold">
            Добавлен в черный список:
          </v-col>
          <v-col cols="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                    :color="checkBlackListFlag(item.is_in_blacklist).color"
                    dark
                    v-bind="attrs"
                    v-on="on"
                >
                  {{checkBlackListFlag(item.is_in_blacklist).icon}}
                </v-icon>
              </template>
              <span>{{checkBlackListFlag(item.is_in_blacklist).text}}</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-divider class="grey my-2" v-if="isGetCar(item)"></v-divider>
        <v-row no-gutters class="text-center subtitle-1" v-if="isGetCar(item)">
          <v-col cols="12" class="font-weight-bold">Автомобили посетителя</v-col>
        </v-row>
        <v-divider class="grey my-2" v-if="isGetCar(item)"></v-divider>
        <v-data-table
            v-if="isGetCar(item)"
            :headers="headers"
            :items="item.cars"
            :footer-props="{'items-per-page-options':[10,15,25]}"
        >
        </v-data-table>
      </v-card-text>
    </v-card>
</template>

<script>

export default {
  name: "VisitorsDetail",
  props: ["item"],
  data() {
    return {
      headers: [
        {text: "Номер", value: "number", sortable: false, align: "start", width: "50%"},
        {text: "Модель", value: "model", sortable: false, align: "start", width: "50%"}
      ]
    }
  },
  methods: {
    isGetCar(item){
      if (item.cars) {
        if (item.cars.length > 0) {
          return true
        }
      } else {
        return false
      }
    },
    checkFlag(flag) {
      if (flag) return {icon: "check_circle", color: "green"}
      else return {icon: "radio_button_unchecked", color: "grey"}
    },
    checkBlackListFlag(flag) {
      if (flag === true) return {icon: "do_not_disturb_on", color: "red", text: "Пользователь в черном списке"}
      else if (flag === false) return {icon: "radio_button_unchecked", color: "grey", text: "Ограничений нет"}
      else return {icon: "error", color: "yellow darken-2", text: "Пользователь в сером списке"}
    }
  }
}
</script>

<style scoped>
.removeBtnPaddingRight>>>.v-toolbar__content{
  padding-right: 0px;
}
</style>
